import SelectMenu from '@/components/basic/SelectMenu/SelectMenu';
import { IUserFull } from '@gettactic/api';
import { useUserListByIds, useUserListPaginated } from '@gettactic/hooks';
import { useEffect, useMemo, useState } from 'react';

type Props = {
  onChange: (id: string) => void;
  value: string;
  className?: string;
};

export const SelectSingleUser = ({ className, onChange, value }: Props) => {
  const [missingUsers, setMissingUsers] = useState<string[]>([]);
  const [query, setQuery] = useState('');
  const userList = useUserListPaginated(query, 10);
  const users = userList.allPages;
  const userIncludeList = useUserListByIds(missingUsers);
  useEffect(() => {
    if (userList.isFetching) {
      return;
    }
    const missing = [value].filter((x) => !users.some((y) => y.id === x));
    setMissingUsers(missing);
  }, [value, userList.isFetching, users]);
  const options = useMemo(() => {
    return users
      .concat((userIncludeList.data as IUserFull[]) ?? [])
      .map((x) => ({ label: x.name, value: x.id }));
  }, [users, userIncludeList.data]);

  return (
    <>
      <SelectMenu
        maxAllowed={1}
        className={className}
        nonePlaceholder={'Select Employees'}
        allPlaceholder={'All Employees'}
        options={options}
        values={[value]}
        onChange={(x) => onChange(x[0])}
        onQueryUpdate={(x) => setQuery(x)}
        hasNextPage={userList.hasNextPage}
        fetchNextPage={userList.fetchNextPage}
        isFetchingNextPage={userList.isFetchingNextPage}
      />
    </>
  );
};
